import { Component } from "react";
import { timeToFloat } from "../../../time";
import moment from "moment";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import CustomizedTextField from "../../Input/CustomizedTextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import { Typography, Button, Icon } from "@mui/material";
import { generateTotalTimeSpentOnWorkOrder } from "../../../redux/intervention/interventionActions";
import { connect } from "react-redux";
import { compose } from "redux";
import IntegerInputWithChips from "../../Input/IntegerInputWithChips";
import ValidateIcon from "@mui/icons-material/Check";
import { tryParseInt } from "../../../utils";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class InterventionNbHoursField extends Component {
    state = {
        modalOpenned: false,
        minutes: this.getMinutesFromFloat(this.props.value.value_float),
        hours: this.getHoursFromTimeAsFloat(this.props.value.value_float),
        choosingInputMode: false,
    };

    timeChange(hours, minutes) {
        let fieldValue = this.props.value;
        fieldValue.value_float = timeToFloat(hours, minutes);
        this.props.fieldValueChange(fieldValue);
    }

    openModal() {
        if (!this.props.inputProperties.disabled && !this.state.modalOpenned)
            this.setState({
                modalOpenned: true,
                choosingInputMode: true,
            });
    }

    closeModal() {
        this.setState({ modalOpenned: false });
    }

    onMinutesChange(e) {
        this.setState({
            minutes: e.target.value,
        });
    }

    onHoursChange(e) {
        this.setState({
            hours: tryParseInt(e.target.value, 0),
        });
    }

    getHoursFromTimeAsFloat(timeAsFloat) {
        return parseInt(timeAsFloat);
    }

    getMinutesFromFloat(timeAsFloat) {
        let reminder = timeAsFloat % 1;
        return Math.round(reminder * 60);
    }

    roundToSuperiorInterval(value) {
        const interval = this.props.interval;
        const reminder = interval - (value.minute() % interval);

        if (reminder !== interval) return moment(value).add(reminder, "minutes");
        else return moment(value);
    }

    displayOnlyHour(hoursAsFloat) {
        return parseInt(hoursAsFloat);
    }

    displayOnlyMinutes(hoursAsFloat) {
        let reminder = hoursAsFloat % 1;
        let minutesNb = Math.round(reminder * 60);

        return minutesNb;
    }

    getDisplayableTime(valueAsFloat) {
        let nbHours = this.displayOnlyHour(valueAsFloat);
        let nbMinutes = this.displayOnlyMinutes(valueAsFloat);

        return nbHours + ":" + nbMinutes;
    }

    actualizeTimeSpent() {
        let totalTimeSpent = generateTotalTimeSpentOnWorkOrder(this.props.intervention, this.props.blocTypes);

        let nbHours = parseInt(totalTimeSpent);
        let nbMinutes = parseInt((totalTimeSpent - nbHours) * 60);

        let date = new Date(0, 0, 1, nbHours, nbMinutes, 0);
        if (this.props.interval) date = this.roundToSuperiorInterval(moment(date)).toDate();

        let nbDaysInHour = (date.getDay() - 1) * 24;
        let totalHours = date.getHours() + nbDaysInHour;

        this.setState({
            minutes: date.getMinutes(),
            hours: totalHours,
        });
        this.validateTimeModal(null, totalHours, date.getMinutes());
    }

    validateTimeModal(e, forcedHours, forcedMinutes) {
        this.timeChange(forcedHours || this.state.hours, forcedMinutes || this.state.minutes);

        this.closeModal();
    }

    choosedInputMode() {
        this.setState({ choosingInputMode: false });
    }

    manualInput() {
        this.choosedInputMode();
    }

    calculatePassedTime() {
        this.choosedInputMode();
        this.actualizeTimeSpent();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.hours !== nextState.hours ||
            this.state.minutes !== nextState.minutes ||
            this.state.modalOpenned !== nextState.modalOpenned ||
            this.props.value !== nextProps.value ||
            this.props.inputProperties.disabled !== nextProps.inputProperties.disabled ||
            this.state.choosingInputMode !== nextState.choosingInputMode
        );
    }

    onChipClick(chip) {
        this.setState({
            minutes: chip.value,
        });
    }

    onHoursFieldClick = (ev) => {
        const el = ev.target;
        if (document.activeElement !== el) {
            setTimeout(() => {
                if (el.select) el.select();
            }, 0);
        }
    };

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;
        let currentValue = this.getDisplayableTime(this.props.value.value_float);

        return (
            <div className="row control-margin-top">
                <div className="without-side-padding col-lg-12 col-md-12 col-sm-12 col-12">
                    <CustomizedTextField
                        onMouseDown={this.openModal.bind(this)}
                        inputProps={{ onClick: this.openModal.bind(this) }}
                        label={this.props.model.name}
                        {...this.props.inputProperties}
                        value={currentValue}
                        className={this.props.inputProperties.className + " full_size control-margin-top"}
                    />
                </div>
                <Dialog
                    aria-labelledby="simple-dialog-title"
                    open={this.state.modalOpenned}
                    onClose={this.closeModal.bind(this)}
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.closeModal.bind(this)} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {this.props.model.name}
                            </Typography>
                            {!this.state.choosingInputMode && (
                                <IconButton
                                    color="inherit"
                                    onClick={this.validateTimeModal.bind(this)}
                                    aria-label="Validate"
                                >
                                    <ValidateIcon />
                                </IconButton>
                            )}
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                    <DialogContent>
                        {this.state.choosingInputMode ? (
                            <div>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={this.manualInput.bind(this)}
                                    className="div-center control-margin-top"
                                    disabled={this.props.inputProperties.disabled}
                                >
                                    <Icon>edit</Icon>
                                    <Typography
                                        variant="subtitle1"
                                        color="inherit"
                                        className="full_size btn-actualize-time-font"
                                    >
                                        {"Saisie manuelle"}
                                    </Typography>
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={this.calculatePassedTime.bind(this)}
                                    className="div-center control-margin-top"
                                    disabled={this.props.inputProperties.disabled}
                                >
                                    <Icon>autorenew</Icon>
                                    <Typography
                                        variant="subtitle1"
                                        color="inherit"
                                        className="full_size btn-actualize-time-font"
                                    >
                                        {"Calcul automatique"}
                                    </Typography>
                                </Button>
                            </div>
                        ) : (
                            <div>
                                <CustomizedTextField
                                    onChange={this.onHoursChange.bind(this)}
                                    label={"Heures"}
                                    {...this.props.inputProperties}
                                    type={"number"}
                                    value={this.state.hours}
                                    onMouseDown={this.onHoursFieldClick.bind(this)}
                                    className={this.props.inputProperties.className + " full_size control-margin-top"}
                                />
                                <div className="control-margin-top">
                                    <IntegerInputWithChips
                                        min={0}
                                        max={59}
                                        step={Math.max(this.props.interval, 1)}
                                        id="minutes"
                                        label="minutes"
                                        onClick={this.onChipClick.bind(this)}
                                        multipleSelection={false}
                                        selectedValue={this.state.minutes}
                                    />
                                </div>
                            </div>
                        )}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(InterventionNbHoursField);
